import React from "react";
import PropTypes from "prop-types";
import LazyImage from "../components/LazyImage/LazyImage";

const CardFeaturedImage = ({
  imageUrl,
  alt,
  width = "100%",
  height = "100%",
  className = "",
  imgClassName = "",
  aspectRatio = "16/7",
  imageStyle = {}
}) => {
  return (
    <div className={`card__featured-wrapper ${className}`}>
      <LazyImage
        src={imageUrl}
        alt={alt}
        width={width}
        height={height}
        aspectRatio={aspectRatio}
        imgClassName={imgClassName}
        className="card__image--featured zoom-hover__inner"
        style={imageStyle}
      />
    </div>
  );
};

CardFeaturedImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  imgClassName: PropTypes.string
};

export default CardFeaturedImage;
